module.exports = __webpack_public_path__ + "static/media/pdfpng.5af86012.svg";